import { render, staticRenderFns } from "./Page2.vue?vue&type=template&id=e0f060ae&scoped=true"
import script from "./Page2.vue?vue&type=script&lang=js"
export * from "./Page2.vue?vue&type=script&lang=js"
import style0 from "./Page2.vue?vue&type=style&index=0&id=e0f060ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f060ae",
  null
  
)

export default component.exports